import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/lexend';
import '@fontsource-variable/jetbrains-mono';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
